// Cantons de Suisse romande (francophones) — 6 cantons.
// Drapeaux servis depuis Wikimedia Commons via Special:FilePath.
const flag = (filename) =>
  `https://commons.wikimedia.org/wiki/Special:FilePath/Flag_of_Canton_of_${filename}.svg?width=200`;

export const CANTONS = [
  { code: "ge", name: { fr: "Genève", de: "Genf", en: "Geneva" }, capital: "Genève", flag: flag("Geneva") },
  { code: "vd", name: { fr: "Vaud", de: "Waadt", en: "Vaud" }, capital: "Lausanne", flag: flag("Vaud") },
  { code: "ne", name: { fr: "Neuchâtel", de: "Neuenburg", en: "Neuchâtel" }, capital: "Neuchâtel", flag: flag("Neuch%C3%A2tel") },
  { code: "ju", name: { fr: "Jura", de: "Jura", en: "Jura" }, capital: "Delémont", flag: flag("Jura") },
  { code: "fr", name: { fr: "Fribourg", de: "Freiburg", en: "Fribourg" }, capital: "Fribourg", flag: flag("Fribourg") },
  { code: "vs", name: { fr: "Valais", de: "Wallis", en: "Valais" }, capital: "Sion", flag: flag("Valais") },
];
